import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import Hidden from "@material-ui/core/Hidden";
import { Routes } from "../../../constants/routes";
import FormLink from "../../../components/FormLink";
import Typography from "@material-ui/core/Typography";
import TextDivider from "../../../components/TextDivider";
import { registerParentFormValidator } from "../utils/validators/registerForm";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { texts } from "../constants/texts";
import { useWizard } from "../../wizard/context";
import RegisterParentForm from "./forms/RegisterParentForm";
import { UserRole } from "../../user/enums/UserRole";

const useStyles = makeStyles(() => ({
  footer: {
    marginTop: 40,
  },
}));

function RegisterParentWidget() {
  const {
    actions: { register },
  } = useAuth();

  const classes = useStyles();

  const { openWizard } = useWizard();

  const openModal = () => {
    openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "OOPS.",
          },
          content: texts.warningMessage,
        },
      ],
      submitButtonText: "Ok",
      cancelButtonText: null,
    });
  };

  function _submit(data) {
    const errors = registerParentFormValidator(data, openModal);

    if (
      Object.keys(errors).length > 0
    ) {
      return errors;
    }

    return register(data, UserRole.Parent);
  }

  return (
    <>
      <Form onSubmit={_submit} component={RegisterParentForm} />

      <Hidden mdUp>
        <div className={classes.footer}>
          <TextDivider text={"OR"} />
          <Typography component="p" align="center">
            Already Registered?{" "}
            <FormLink to={`/${Routes.LOGIN}`}>Sign In</FormLink>
          </Typography>
        </div>
      </Hidden>
    </>
  );
}

export default React.memo(RegisterParentWidget);
